import { OverridableComponent } from '@mui/material/OverridableComponent';
import { Stack, SvgIconTypeMap } from '@mui/material';

interface GradientIconProps {
  color: 'primary' | 'secondary' | 'info' | 'warning' | 'error';
  IconComponent: OverridableComponent<SvgIconTypeMap<object, 'svg'>> & { muiName: string };
}

export const GradientIcon = ({ color, IconComponent }: GradientIconProps) => (
  <Stack
    alignItems="center"
    justifyContent="center"
    flexShrink="0"
    borderRadius="24px"
    bgcolor={(theme) => `${theme.palette[color].light}33`}
    sx={{ width: '48px', height: '48px' }}
  >
    <Stack
      alignItems="center"
      justifyContent="center"
      flexShrink="0"
      borderRadius="24px"
      bgcolor={(theme) => `${theme.palette[color].light}33`}
      sx={{ width: '36px', height: '36px' }}
    >
      <IconComponent opacity={0.6} color="secondary" />
    </Stack>
  </Stack>
);
